import { render, staticRenderFns } from "./ProcessModal.vue?vue&type=template&id=95c88cba&scoped=true&"
import script from "./ProcessModal.vue?vue&type=script&lang=js&"
export * from "./ProcessModal.vue?vue&type=script&lang=js&"
import style0 from "./ProcessModal.vue?vue&type=style&index=0&id=95c88cba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95c88cba",
  null
  
)

export default component.exports